import { render, staticRenderFns } from "./CustomerPersonPage.vue?vue&type=template&id=1f41a060&"
import script from "./CustomerPersonPage.vue?vue&type=script&lang=ts&"
export * from "./CustomerPersonPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports